import { Box } from "@compass/core";
import { useEffect } from "react";
import { AppRoutes } from "routes";
import ApiService from "services/apiService";

ApiService.initializeApi();

export default function App() {
  return (
    <Box className="app" ml="auto" mr="auto">
      <AppRoutes />
    </Box>
  );
}
